import React from 'react';

interface FadeInProps {
  children: React.ReactNode;
  direction?: 'up' | 'down' | 'left' | 'right';
  delay?: number;
  duration?: number;
  className?: string;
}

export const FadeIn: React.FC<FadeInProps> = ({
  children,
  direction = 'up',
  delay = 0,
  duration = 500,
  className = ''
}) => {
  const directionClasses = {
    up: 'translate-y-8',
    down: '-translate-y-8',
    left: 'translate-x-8',
    right: '-translate-x-8'
  };

  return (
    <div 
      className={`opacity-0 ${directionClasses[direction]} transition-all duration-${duration} ${className}`}
      style={{ 
        animationDelay: `${delay}ms`,
        animation: `fadeIn ${duration}ms ease-out ${delay}ms forwards`
      }}
    >
      {children}
    </div>
  );
};

interface HoverScaleProps {
  children: React.ReactNode;
  scale?: number;
  className?: string;
}

export const HoverScale: React.FC<HoverScaleProps> = ({
  children,
  scale = 1.05,
  className = ''
}) => (
  <div className={`transition-transform duration-300 hover:scale-${Math.round(scale * 100)} ${className}`}>
    {children}
  </div>
);

interface PulseProps {
  children: React.ReactNode;
  className?: string;
  intense?: boolean;
}

export const Pulse: React.FC<PulseProps> = ({
  children,
  className = '',
  intense = false
}) => (
  <div className={`${intense ? 'animate-pulse' : 'animate-pulse-slow'} ${className}`}>
    {children}
  </div>
);

interface FloatProps {
  children: React.ReactNode;
  className?: string;
}

export const Float: React.FC<FloatProps> = ({
  children,
  className = ''
}) => (
  <div className={`animate-float ${className}`}>
    {children}
  </div>
);

// CSS animations to add to global styles
export const animationCSS = `
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`;
